import { tenant } from "../../tenants/tenant-configs/emergency.tenant";

export const environment = {
  apiUrl: tenant.apiUrl,
  envName: 'uat' as const,
  appVersion: '1.0',
  appYear: '2026',
  appName: tenant.brandName,
  production: false,
  amplify: {
    userPoolId: tenant.amplifyConfig.nativeAuth.userPoolId,
    userPoolClientId: tenant.amplifyConfig.nativeAuth.userPoolWebClientId,
    identityPoolId: undefined, // Optional - only needed for AWS service access (S3, DynamoDB, etc.)
    region: tenant.amplifyConfig.nativeAuth.region,
    oauth: {
      domain: tenant.amplifyConfig.nativeAuth.oauth.domain,
      scope: tenant.amplifyConfig.nativeAuth.oauth.scope,
      redirectSignIn: tenant.amplifyConfig.nativeAuth.oauth.redirectSignIn,
      redirectSignOut: tenant.amplifyConfig.nativeAuth.oauth.redirectSignOut,
      responseType: tenant.amplifyConfig.nativeAuth.oauth.responseType,
    },
    authenticationFlowType: tenant.amplifyConfig.nativeAuth.authenticationFlowType,
    mandatorySignIn: tenant.amplifyConfig.nativeAuth.mandatorySignIn,
  },
};
